import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMenuService, NbSidebarService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
@Component({
  selector: 'ngx-one-column-layout',
  styleUrls: ['./one-column.layout.scss'],
  template: `
    <nb-layout windowMode>
      <nb-layout-header fixed>
        <ngx-header></ngx-header>
      </nb-layout-header>

      <nb-sidebar class="menu-sidebar" tag="menu-sidebar" responsive>
        <ng-content select="nb-menu"></ng-content>
        <ng-content select=""></ng-content>
        <nb-sidebar-footer class="lang-select">
          <button class="lang-button" (click)="setLang('pl')" nbButton size="small" shape="round">PL</button>
          <button class="lang-button" (click)="setLang('en')" nbButton size="small" shape="round">EN</button>
        </nb-sidebar-footer>
      </nb-sidebar>

      <nb-layout-column>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>

    </nb-layout>
  `,
})
export class OneColumnLayoutComponent implements OnInit, OnDestroy{
  constructor(private translate: TranslateService, private menuService: NbMenuService, private sidebarService: NbSidebarService) {}
  private destroy$ = new Subject<void>();
  
  ngOnInit(): void {
    this.menuWatcher();
  }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  setLang(lang: string) {
    this.translate.use(lang);
  }

  menuWatcher() {
    this.menuService.onSubmenuToggle()
      .pipe(takeUntil(this.destroy$))
      .subscribe((menuBag) => {
        this.sidebarService.getSidebarState('menu-sidebar').subscribe((state) => {
          if(state == 'compacted'){
            if(menuBag?.item)
            menuBag.item.expanded = true;
          }
        });
      });
  }
}
